// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseMappingListActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { withHandlers } from 'recompose';
import { curry } from 'lodash/fp';
import { KEY_TO_DATABASE_NAME } from 'logic/data/Izenda.ImportConstants';

/**
 * Handle when change selected to database name
 * @param {Object} props
 * @param {Object} data
 * @param {string} id
 * @param {string} value
 */
function onChangeToDatabaseName(props: any, data: any, id: string, value: string) {
  const { store, store: { model } } = props;

  store.getSchemas(id).then(schemas => {
    const groupIndexs = model.updateSelectedToDatabaseName(data, id, value, schemas);
    groupIndexs.forEach(item => {
      props.validation.reset(KEY_TO_DATABASE_NAME, item);
    });
  });
}

export default withHandlers({
  onChangeToDatabaseName: curry(onChangeToDatabaseName)
});



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/DatabaseMapping/Izenda.DatabaseMappingListActions.js